export class VisitSynchronizationStatus {
  constructor(
    readonly synchronizedAt: string,
    readonly numberOfVisits: number,
  ) {}
}
